module.exports = __webpack_public_path__ + "img/sup_cardsetting_ewallet2.c803619c.jpg";